/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Birth_MonthInputs */

const en_us2_profile_editors_birth_month = /** @type {(inputs: Profile_Editors_Birth_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month`)
};

const pt_br2_profile_editors_birth_month = /** @type {(inputs: Profile_Editors_Birth_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês`)
};

const es_419_profile_editors_birth_month = /** @type {(inputs: Profile_Editors_Birth_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes`)
};

const pt_pt2_profile_editors_birth_month = /** @type {(inputs: Profile_Editors_Birth_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês`)
};

const fr_fr2_profile_editors_birth_month = /** @type {(inputs: Profile_Editors_Birth_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois`)
};

const de_de2_profile_editors_birth_month = /** @type {(inputs: Profile_Editors_Birth_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

const it_it2_profile_editors_birth_month = /** @type {(inputs: Profile_Editors_Birth_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mese`)
};

/**
* | output |
* | --- |
* | "Month" |
*
* @param {Profile_Editors_Birth_MonthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_birth_month = /** @type {((inputs?: Profile_Editors_Birth_MonthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Birth_MonthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_birth_month(inputs)
	if (locale === "es-419") return es_419_profile_editors_birth_month(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_birth_month(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_birth_month(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_birth_month(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_birth_month(inputs)
	return en_us2_profile_editors_birth_month(inputs)
});
export { profile_editors_birth_month as "profile-editors.birth_month" }